import { memo, ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
  className: string
};

export const RegionInfoItem = memo(({ title, children, className }: Props) => {
  return (
    <div className={`bg-bgLight rounded-[6px] px-2.5 py-2 ${className}`}>
      <h6 className="text-grayDark">{title}</h6>
      {children}
    </div>
  );
});
